import getClusterResolutions from "../../../utils/get-cluster-resolutions";
import getOptionData from "./get-option-data";
import getOptionName from "./get-option-name";

/**
 * Get array of splitted options/parameters and return its "resolutions" object
 * @param {Array<String>} parameters
 * @param {MainClassProps | null} main
 * @param {Boolean} isOption Is value option or trigger parameter
 * @param {Number} count
 * @param {Boolean} coordinates
 * @param {Boolean} useBounds
 * @returns {OptionsProps}
 */
const processOptionResolutions = (
  parameters,
  main,
  isOption,
  count,
  coordinates,
  useBounds = false
) => {
  const values = new Map();

  for (const item of parameters) {
    /** @type {StorageItemProps} */
    const map = new Map();

    /** Option data from string */
    const data = getOptionData(item, isOption);

    /** Option name. If it's shorthand without parameters, use original string */
    const name = getOptionName(values, data, item);

    /** Option value */
    const value = data.get("rest") || "";

    /** Value resolutions */
    const resolutions = getClusterResolutions(value, 0, name);

    /** Is option flag */
    map.set("is-option", isOption);

    /** Is parameter flag */
    map.set("is-parameter", !isOption);

    /** In cases where parameter is a function, the inner values inherits it's name */
    map.set("parent-item", null);

    /** Is coordinates-based parameter */
    map.set("is-coordinates-based", coordinates);

    /** Is bounds parameter */
    map.set("use-bounds", useBounds);

    /** Check if the option is target to get the DOM node later */
    map.set("is-target", name === "target");

    /** Original string */
    map.set("original", item);

    /** Option name */
    map.set("name", name);

    /** Option values resolution */
    map.set("resolutions", resolutions);

    /** Step count. Will be used to divide the duration according the step count */
    map.set("duration-divide", count || 0);

    /**
     * Option values in the `Map<"name", rest>` format
     * @example `"duration" => {'original' => 'duration˸[1s✦xl▹0.5s]', 'resolutions' => Map(2)}`
     */
    values.set(name, map);

    if (main) {
      const storage = /** @type {Array<any>} */ (main?.storage.get("values"));
      storage?.push(map);
    }
  }

  return values;
};

export default processOptionResolutions;
